/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Equivalent_MonthlyInputs */

const en_plan_equivalent_monthly = /** @type {(inputs: Plan_Equivalent_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivalent to ${i?.price}/mo`)
};

const es_plan_equivalent_monthly = /** @type {(inputs: Plan_Equivalent_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivalente a ${i?.price}/mes`)
};

/**
* | output |
* | --- |
* | "Equivalent to {price}/mo" |
*
* @param {Plan_Equivalent_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_equivalent_monthly = /** @type {((inputs: Plan_Equivalent_MonthlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Equivalent_MonthlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_equivalent_monthly(inputs)
	return en_plan_equivalent_monthly(inputs)
});